import React, { createContext, useContext, useMemo } from 'react';

interface ContextValue {
  isPreviewMode: boolean;
  hoveredId?: string;
  sellectedId?: string;
}

export const FillInTheBlanksContext = createContext<ContextValue>({
  isPreviewMode: false,
});

export const useFillInTheBlanksContext = () => {
  const context = useContext(FillInTheBlanksContext);
  if (!context) {
    throw new Error('useFillInTheBlanksContext must be used within a FillInTheBlanksContext');
  }
  return context;
};

export const FillInTheBlanksContextProvider = ({
  children,
  isPreviewMode,
  hoveredId,
  sellectedId,
}: {
  children: React.ReactNode;
  isPreviewMode: boolean;
  hoveredId?: string;
  sellectedId?: string;
}) => {
  const value = useMemo(() => ({ isPreviewMode, hoveredId, sellectedId }), [isPreviewMode, hoveredId, sellectedId]);

  return <FillInTheBlanksContext.Provider value={value}>{children}</FillInTheBlanksContext.Provider>;
};
